import {createSlice} from '@reduxjs/toolkit';

// ---- import from local actions ----
import {fetchRolePermissionList} from './../actions/RolePermissionActions';


const RolePermissionSlice = createSlice({
  name: 'rolePermission',
  initialState: {
    rolePermissionList: {
      data: [],
      status: 'idle',
      error: '',
      loading: false,
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchRolePermissionList.pending, (state) => {
        state.rolePermissionList.status = 'loading';
      })
      .addCase(fetchRolePermissionList.fulfilled, (state, action) => {
        state.rolePermissionList.status = 'idle';
        state.rolePermissionList.data = action.payload.result;
      })
      .addCase(fetchRolePermissionList.rejected, (state, action) => {
        state.rolePermissionList.status = 'rejected';
        state.rolePermissionList.error = action.error.message;
      });
  },
});

export default RolePermissionSlice.reducer;
